import styles from './ManagementPopularity.module.scss'
import { useTranslation } from "next-i18next";
import { H2, P3 } from "../../../../components/Typography";
import Image from "next/image";
import cl from "classnames";
import { Button } from '@/lib/ui/components/Buttons';
import { FeedBackModalNew, modal } from '@/lib/ui/components/Modal';

export const ManagementPopularity = () => {
    const { t } = useTranslation("index", { keyPrefix: "managementPage" });

    const toCallModal = () => {
        modal.open(
        <FeedBackModalNew 
            eventName={["others"]} 
            title='getOccupancy' 
            comment='Получить прогноз заполняемости объекта'
            sourceForm='request_occupancy_forecast'
            leadType='COOP'
        />, {
          isFeedBackNew: true,
        });
      };
    return (
        <div className={styles.popularity}>
            <div className={cl(styles.container, styles.popularity__wrapper)}>
            <div className={styles.popularity_leaves}>
                <Image 
                    sizes="(min-width: 1000px) 1474px, 1031px"
                    src={'/image.webp'} 
                    alt={'leaves'} 
                    fill
                />
            </div>
            <div>
                <H2 className={styles.popularity__title}>{t('popularity.title')}</H2>
                <P3 className={styles.popularity__text}>{t('popularity.text')}</P3>
                <Button
                    as={"button"}
                    label={t('popularity.buttonLabel')}
                    theme={"dark"}
                    size={"lg"}
                    onClick={toCallModal}
                />
            </div>
            <div className={styles.popularity__cardsWrapper}>
                <div className={cl(styles.popularity__card, styles['popularity__card--left'])}>
                    <Image 
                        sizes="(min-width: 1000px) 266px, 166px"
                        src={'/images/management/airCard.webp'} 
                        loader={({ src }) => src}
                        alt={'Air Bnb Icon'} 
                        width={166}
                        height={227}
                    />
                </div>  
                <div className={cl(styles.popularity__card, styles['popularity__card--right'])}>
                    <Image 
                        sizes="(min-width: 1000px) 266px, 166px"
                        src={'/images/management/bookingCard.webp'}
                        loader={({ src }) => src} 
                        alt={'Bokking Icon'} 
                        width={166}
                        height={227}
                    />
                </div>  
                   
            </div>
            </div>
           
        </div>
    )
}